import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/i18n/LanguageProvider";
import { buildPath } from "@/lib/routes";
import {
  ANALYTICS_CONSENT_KEY,
  updateAnalyticsConsent,
} from "@/analytics/AnalyticsBootstrap";

export function CookieBanner() {
  const { lang, t } = useLang();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const choice = localStorage.getItem(ANALYTICS_CONSENT_KEY);
    if (!choice || choice === "essential") setShow(true);
  }, []);

  const setConsent = (analytics) => {
    updateAnalyticsConsent(analytics);
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-50 border-t border-line bg-white p-4 shadow-[0_-4px_20px_rgba(0,0,0,0.04)] md:bottom-4 md:left-4 md:right-auto md:max-w-md md:rounded-lg md:border" data-testid="cookie-banner">
      <p className="text-[14px] leading-relaxed text-ink-soft">{t("cookie.text")}</p>
      <div className="mt-3 flex items-center gap-4">
        <button onClick={() => setConsent(true)} data-testid="cookie-accept" className="rounded-full bg-petrol px-5 py-2 text-[14px] font-semibold text-white hover:bg-petrol-dark">
          {t("cookie.accept")}
        </button>
        <button onClick={() => setConsent(false)} data-testid="cookie-essential-only" className="text-[13px] text-ink-soft underline underline-offset-2 hover:text-petrol">
          {t("cookie.essentialOnly")}
        </button>
        <Link to={buildPath("cookies", lang)} className="text-[13px] text-ink-soft underline underline-offset-2 hover:text-petrol">
          {t("legal.cookies")}
        </Link>
      </div>
    </div>
  );
}
